import * as React from 'react'

export type ShellLayout = 'expanded' | 'collapsed' | 'drawer'

/*
 * Shell responsiveness follows the VisitOne contract:
 * expanded rail from 1280px, collapsed rail from 900–1279px, drawer below 900px.
 */
export function useShellLayout(): ShellLayout {
  const [layout, setLayout] = React.useState<ShellLayout>('expanded')

  React.useEffect(() => {
    const compute = () => {
      const width = window.innerWidth
      if (width >= 1280) setLayout('expanded')
      else if (width >= 900) setLayout('collapsed')
      else setLayout('drawer')
    }
    compute()
    window.addEventListener('resize', compute)
    return () => window.removeEventListener('resize', compute)
  }, [])

  return layout
}
